import { Button, Checkbox, DatePicker, Input, InputNumber, Modal, Select, Table } from 'antd'
import { Option } from 'antd/es/mentions'
import React, { useState, useEffect } from 'react'
 import "../MainCSS.css";
import 'aos/dist/aos.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import TextArea from 'antd/es/input/TextArea'
import { ChangeStatusOfJobWork, DeletePackingJobWorkData, GenerateDispatchNo, GenerateJobWorkNo, GetAllJobWorkDispatch, GetDispatchDataByMonth, GetDispatchDetails, GetDispatchPackingDetails, GetJobWorkDetails, GetJobWorkDetailsDispatch, GetJobWorkDropdown, GetJobWorkPackingDetails, SaveDispatchDetails, SaveJobWork, SaveJObWorkDispatch, SelectedJobWorkDetails, UpdateDispatchDetails } from '../../AllAPI/DispatchAPI/DispatchApi';
import dayjs from 'dayjs';
import { GetWorkerMaster } from '../../AllAPI/MasterAPI/GeneralMasterApi';
import DataTable from 'react-data-table-component';

const JobWorkDispatch = () =>{
  const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {}
  // const storedUserData = sessionStorage.getItem('userData') || '';

  const commonHeaders = {
    headers: {
      // createdBy: storedUserData || '',
      // updatedBy: storedUserData || '',
      createdBy: 1,
      updatedBy: 2,
      userIp: storedHeaders.userIp || '',
      userLat: storedHeaders.userLat || '',
      userLong: storedHeaders.userLong || '',
      deviceSign: storedHeaders.deviceSign || '',
    },
  }

  const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }






  const [packingId, setPackingId] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false);
    const [JobWorkId, setJobWorkId] = useState('')

   const [JobWork, setJobWork] = useState('');
  const [dispatchDate, setDispatchDate] = useState(null); // or moment() for default current date
const[allWorker,setAllWorker]=useState([]);
  const [totalWeight, setTotalWeight] = useState('');
  const [vehicleNo, setVehicleNo] = useState('');
  const [remark, setRemark] = useState('');
  const [JobWorkData, setJobWorkData] = useState([]);
    const[jobWorker ,setJobWorker]= useState('');
  const [errors, setErrors] = useState({
   remark,
   vehicleNo,
   JobWork,
   jobWorker,
  })
  
  // Fetch OrderEntry, Customer and Item Names
  let isJobWorkDataFetched = false
  useEffect(() => {
    if (isJobWorkDataFetched) return
 fetchJobWorkDispatch();
  fetchWorker();

    isJobWorkDataFetched = true
  }, [])


useEffect(() => {
  if(jobWorker){
    fetchJobWorkData();
  }
  
    if (jobWorker && JobWork) { 
        fetchJobWorkDataForDispatch();
    }
}, [jobWorker,JobWork]);
  //=========================================
  let isError = false


  const fetchWorker = async () => {
    try {
      const response = await axios.get(GetWorkerMaster,commonHeaders1);
      if (response.data !== null) {
        setAllWorker(response.data);
        
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Worker:", error);
        toast.error("Failed to fetch Worker data");
        isError = true; 
      }
    }
  };
   const fetchJobWorkData = async () => {
    try {
      const response = await axios.get(`${GetJobWorkDropdown}?jobWorkerId=${jobWorker}`, commonHeaders1)
     const JobWorkDetails = response.data;

    if (!JobWorkDetails) {
      toast.error("Failed to fetch order details.");
      return;
    }

    if (Array.isArray(JobWorkDetails) && JobWorkDetails.length > 0) {
      setJobWorkData(JobWorkDetails);
    
    } else {
      toast.warn("No work alloted to the selected job worker.");
      setJobWorkData([]);
    }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching  JobWork Data:', error)
        toast.error('Failed to fetch  JobWork Data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  // 3. Submit Button=======================================================================
  const handleJobWorkSubmit = async () => {
    let isValid = true
    const errorObj = {}

  if (!vehicleNo) {
    isValid = false;
    errorObj.vehicleNo = "Vehicle Number is required";
  }
 

  if (!remark) {
    isValid = false;
    errorObj.remark = "Remark is required";
  }   if (!JobWork) {
    isValid = false;
    errorObj.JobWork = "Job Work is required";
  }
   if (!jobWorker) {
    isValid = false;
    errorObj.jobWorker = "Job Worker is required";
  }


    setErrors(errorObj) // Set error messages

    if (!isValid) return


// Generate packingRateDetails from JobWorkForDispatchData, with jobWorkRate for each packingId
// const packingRateDetails = JobWorkForDispatchData.map(item => ({
//   packingId: item.packingId,
//   jobWorkRate: item.jobWorkRate // Assuming jobWorkRate is part of your JobWorkForDispatchData items
// }));
// Create packingRateDetails using only selected items
const packingRateDetails = selectedItems.map(item => ({
  packingId: item.packingId,
  jobWorkRate: item.jobWorkRate,
}));

// Create the payload
const payload = {

  jobWorkNumberId: JobWork, 
  jobWorkerId: jobWorker, 
  vehicleNumber: vehicleNo, 
  remark: remark,
  packingRateDetails: packingRateDetails, // Your newly transformed packingRateDetails array
};

console.log(payload);
    try {
      const response = await axios.post(
        SaveJObWorkDispatch,
        payload,
        commonHeaders,
      )
   
      if (response.data == 'CREATED') {
        toast.success('Data submitted successfully!')
        handleJobWorkCancel();
       fetchJobWorkDispatch();
        
      }
      else if (response.data == "ALREADYEXISTED") {
        toast.warn('Data Already Exist!')
      }
    } catch (err) {
      console.error('Error submitting data', err)
    }
  }
const   handleJobWorkCancel = () =>{
  setDispatchDate("");
  setVehicleNo("");
  setRemark("");
  setTotalWeight("");
   setJobWork("");
  setJobWorker("");
  setJobWorkForDispatchData([]);
  setFilteredData1([]);
  setTotalEntries1(0);

}
const handleCancel =() =>{
    setDispatchDate("");
  setVehicleNo("");
  setRemark("");
    setJobWorker("");

}
  //===========================================
  const unitOptions = [
    { value: '1', label: 'FT' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'INCH' },
  ]

  //===============================================

  //======Todays JobWork Details Data Table===============


   const [JobWorkDetailsData, setJobWorkDetailsData] = useState([]);
    const [SelectedJobWorkData, setSelectedJobWorkData] = useState([])

  const [filteredData, setFilteredData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = JobWorkDetailsData.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }


  const fetchJobWorkDispatch = async () => {
    try {
      const response = await axios.get(GetAllJobWorkDispatch, commonHeaders1)
     const JobWorkDispatchDetails = response.data;

    if (!JobWorkDispatchDetails) {
      toast.error("Failed to fetch order details.");
      return;
    }

    if (Array.isArray(JobWorkDispatchDetails) && JobWorkDispatchDetails.length > 0) {
      setJobWorkDetailsData(JobWorkDispatchDetails);
      setFilteredData(JobWorkDispatchDetails);
      setTotalEntries(JobWorkDispatchDetails.length);
      // setShowTable(true);
    } else {
      toast.warn("No items found.");
      setJobWorkData([]);
      setFilteredData([]);
      setTotalEntries(0);
      // setShowTable(false);
    }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching  JobWork Data:', error)
        toast.error('Failed to fetch  JobWork Data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

const columns = [
  
  {
    title: 'JobWork ID.',
    dataIndex: 'jobWorkNumberId',
    key: 'jobWorkNumberId',
    sorter: (a, b) => String(a.jobWorkNumberId ?? '').localeCompare(String(b.jobWorkNumberId ?? '')),
  },

   {
    title: 'Job Worker ID',
    dataIndex: 'jobWorkerId',
    key: 'jobWorkerId',
    sorter: (a, b) => String(a.jobWorkerId ?? '').localeCompare(String(b.jobWorkerId ?? '')),
  },
   
  {
    title: 'Vehicle Number',
    dataIndex: 'vehicleName',
    key: 'vehicleName',
    sorter: (a, b) => String(a.vehicleName ?? '').localeCompare(String(b.vehicleName ?? '')),
  },
 {
    title: 'Remark',
    dataIndex: 'remark',
    key: 'remark',
    sorter: (a, b) => String(a.remark ?? '').localeCompare(String(b.remark ?? '')),
  },
  
   {
    title: 'Print',
    key: 'print',
    render: (_, record) => (
       <div>
    
        <span
          type="button"
          style={{ fontSize: "14px", color: "#52c41a", cursor: "pointer" }}
           onClick={() => handlePrint(record)}
          title="Print"
        >
          <i className="fa-solid fa-print"></i>
        </span>
      </div>
    ),
  },

];




  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023e7d',
            color: '#fff',
            padding: '10px',
            fontSize: '15px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
                        fontSize: '15px',

          }}
        >
          {children}
        </td>
      ),
    },
  }

   //======Todays JobWork Details Data Table===============

   const [JobWorkForDispatchData, setJobWorkForDispatchData] = useState([])
   const [filteredData1, setFilteredData1] = useState([])
   const [pageSize1, setPageSize1] = useState(10)
   const [currentPage1, setCurrentPage1] = useState(1)
   const [totalEntries1, setTotalEntries1] = useState(0)
  const[selectedItems,setSelectedItems]=useState([]);
 
   const handleSearch1 = (value) => {
     const searchValue = value.toLowerCase();
   
     const filtered = JobWorkForDispatchData.filter((item) =>
       Object.values(item).some((val) =>
         String(val ?? "").toLowerCase().includes(searchValue)
       )
     );
   
     setFilteredData1(filtered);
     setTotalEntries1(filtered.length);
     setCurrentPage1(1);
   };
   
 
   const handlePageSizeChange1 = (value) => {
     setPageSize1(value)
   }
 
   const fetchJobWorkDataForDispatch = async () => {
     try {
       const response = await axios.get(`${GetJobWorkDetailsDispatch}?jobWorkNumberId=${JobWork}`, commonHeaders1)
   
           if(response.data === 'NOTALLOCATED'){
              toast.warn("Not Allocated ");
            }
if (Array.isArray(response.data) && response.data.length > 0) {
              setJobWorkForDispatchData(response.data);
              setFilteredData1(response.data);
              setTotalEntries1(response.data.length);
              
           }else{
            toast.warn("No data available");
           }
     } catch (error) {
       if (!isError) {
         console.error('Error fetching Data:', error)  
         toast.error('Failed to fetch Data')
         isError = true // Set the flag to prevent double toast
       }
     }
   }
 
// const columns1 = [
//   {
//     title: 'Sr. No.',
//     key: 'index',
//     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
//   },
//   {
//     title: 'Packing ID',
//     dataIndex: 'packingId',
//     key: 'packingId',
//     sorter: (a, b) => (a.packingId ?? '').localeCompare(b.packingId ?? ''),
//   },
//   {
//     title: 'Item Name',
//     dataIndex: 'dieName',
//     key: 'dieName',
//     sorter: (a, b) => (a.dieName ?? '').localeCompare(b.dieName ?? ''),
//   },
//   {
//     title: 'Wt./R',
//     dataIndex: 'weightRange',
//     key: 'weightRange',
//     align: 'right',
//     sorter: (a, b) => (a.weightRange ?? 0) - (b.weightRange ?? 0),
//   },
//   {
//     title: 'Qty',
//     dataIndex: 'pcs',
//     key: 'pcs',
//     align: 'right',
//     sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
//   },
//   {
//     title: 'Actual Basic Rate',
//     dataIndex: 'itemRate',
//     key: 'itemRate',
//     align: 'right',
//     sorter: (a, b) => (a.itemRate ?? 0) - (b.itemRate ?? 0),
//   },
//  {
//     title: 'Actual Total Rate',
//     dataIndex: 'itemRate',
//     key: 'itemRate',
//     align: 'right',
//     sorter: (a, b) => (a.itemRate ?? 0) - (b.itemRate ?? 0),
//   },
//   {
//     title: 'Job Work Rate',
//     dataIndex: 'jobWorkRate',
//     key: 'jobWorkRate',
//     align: 'right',
//     render: (text, record) => (
//       <InputNumber
//         value={record.jobWorkRate || ''} // Use an empty string instead of 0 to handle empty values
//         onChange={(value) => handleRateChange(value, record.id)} // Handle the change event properly
//         style={{ width: '100%' }}
//         min={0}
//         step={0.01} // Optional: to set the step size (default is 1)
//         precision={2} // Optional: set precision for decimal values
//       />
//     ),
//   },
//   {
//     title: 'Select',
//     key: 'select',
//     render: (_, record) => (
//       <Checkbox
//         checked={selectedItems.some(item => item.id === record.id)}
//         onChange={(e) => handleCheckboxChange(e, record)}
//       />
//     ),
//   },
// ];
const handleSelectAllChange = (e) => {
  const { checked } = e.target;
  if (checked) {
    setSelectedItems(filteredData1); // Select all visible/filtered rows
  } else {
    setSelectedItems([]); // Deselect all
  }
};

const handleCheckboxChange = (e, record) => {
  const { checked } = e.target;
  setSelectedItems(prev =>
    checked
      ? [...prev.filter(item => item.packingId !== record.packingId), record]
      : prev.filter(item => item.packingId !== record.packingId)
  );
};


const handleRateChange = (value, packingId) => {
  // Handle the case when the value is an empty string or undefined
  const updatedValue = value === '' || value === null || value === undefined ? null : value;

  setFilteredData1(prev =>
    prev.map(item =>
      item.packingId === packingId ? { ...item, jobWorkRate: updatedValue } : item
    )
  );
  setJobWorkForDispatchData(prev =>
    prev.map(item =>
      item.packingId === packingId ? { ...item, jobWorkRate: updatedValue } : item
    )
  );
};
// const columns1 = [
//   {
//     name: 'Sr. No.',
//     selector: (row, index) => (currentPage1 - 1) * pageSize1 + index + 1,
//     sortable: true,
//     wrap:true,
//   },
//   {
//     name: 'Packing ID',
//     selector: 'packingId',
//     sortable: true,
//     right: true,
//         wrap:true,
//   },
//   {
//     name: 'Item Name',
//     selector: 'dieName',
//     sortable: true,
//         wrap:true,
//   },
//   {
//     name: 'Wt./R',
//     selector: 'weightRange',
//     sortable: true,
//     right: true,
//         wrap:true,
   
//   },
//   {
//     name: 'Qty',
//     selector: 'pcs',
//     sortable: true,
//     right: true,
//         wrap:true,
//   },
//   {
//     name: 'Actual Basic Rate',
//     selector: 'itemRate',
//     sortable: true,
//     right: true,
//     wrap:true,
//   },
//   {
//     name: 'Actual Total Rate',
//     selector: 'itemRate',
//     sortable: true,
//     right: true,
//         wrap:true,
//   },
//   {
//     name: 'Job Work Rate',
//     // selector: 'jobWorkRate',
//     right: true,
//     cell: (row) => (
//       <InputNumber
//         value={row.jobWorkRate || ''}
//         onChange={(value) => handleRateChange(value, row.packingId)} // Handle the change event properly
//         style={{ width: '100%' }}
//         min={0}
//         step={0.01}
//         precision={2}
//       />
//     ),
//   },
//   {
//     name: (
//     <Checkbox
//       onChange={handleSelectAllChange}
//       checked={
//         selectedItems.length > 0 &&
//         selectedItems.length === filteredData1.length
//       }
//       indeterminate={
//         selectedItems.length > 0 &&
//         selectedItems.length < filteredData1.length
//       }
//     />
//   ),
    
//     cell: (row) => (
//       <Checkbox
//         checked={selectedItems.some(item => item.packingId === row.packingId)}
//         onChange={(e) => handleCheckboxChange(e, row)}
//       />
//     ),
//   },
// ];

const columns1 = [
  {
    name: 'Sr. No.',
    selector: (row, index) => (currentPage1 - 1) * pageSize1 + index + 1,
    sortable: true,
    wrap: true,
  },
  {
    name: 'Packing ID',
    selector: row => row.packingId,
    sortable: true,
    right: true,
    wrap: true,
  },
  {
    name: 'Item Name',
    selector: row => row.dieName,
    sortable: true,
    wrap: true,
  },
  {
    name: 'Wt./R',
    selector: row => row.weightRange,
    sortable: true,
    right: true,
    wrap: true,
  },
  {
    name: 'Qty',
    selector: row => row.pcs,
    sortable: true,
    right: true,
    wrap: true,
  },
  {
     name: (
    <div>
   Actual <br />  Basic   <br /> Rate
    </div>
  ),

    selector: row => row.basicOrderRate,
    sortable: true,
    right: true,
    wrap: true,
  },
  {
      name: (
    <div>
   Actual <br />  Total   <br /> Rate
    </div>
  ),
    selector: row => row.totalOrderRate,
    sortable: true,
    right: true,
    wrap: true,
  },
  {
       name: (
    <div>
   Job <br />  Work   <br /> Rate
    </div>
  ),
    selector: row => row.jobWorkRate, // Optional but good practice
    right: true,
    cell: (row) => (
      <InputNumber
        value={row.jobWorkRate || ''}
        onChange={(value) => handleRateChange(value, row.packingId)}
        style={{ width: '100%' }}
        min={0}
        step={0.01}
        precision={2}
      />
    ),
  },
  {
    name: (
      <Checkbox
        onChange={handleSelectAllChange}
        checked={
          selectedItems.length > 0 &&
          selectedItems.length === filteredData1.length
        }
        indeterminate={
          selectedItems.length > 0 &&
          selectedItems.length < filteredData1.length
        }
      />
    ),
    selector: row => row.packingId, // just a dummy selector to satisfy the column config
    cell: (row) => (
      <Checkbox
        checked={selectedItems.some(item => item.packingId === row.packingId)}
        onChange={(e) => handleCheckboxChange(e, row)}
      />
    ),
  },
];

 const paginationOptions = {
    rowsPerPage: pageSize1,
    totalRows: totalEntries1,
    onChangePage: (page) => setCurrentPage1(page),
    onChangeRowsPerPage: handlePageSizeChange1,
  };


 
 const customStyles = {
  headCells: {
    style: {
      backgroundColor: '#000',
      color: '#fff',
      padding: '10px',
      fontSize: '15px',
      borderRadius: '0px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#f0f7fd',
      fontSize: '15px',
    },
  },
  cells: {
    style: {
      padding: '8px',
      fontSize: '15px',
    },
  },
};
  //  const components1 = {
  //    header: {
  //      cell: ({ children, ...restProps }) => (
  //        <th
  //          {...restProps}
  //          style={{
  //            backgroundColor: '#000',
  //            color: '#fff',
  //            padding: '10px',
  //            fontSize: '15px',
  //            borderRadius: '0px',
  //          }}
  //        >
  //          {children}
  //        </th>
  //      ),
  //    },
  //    body: {
  //      row: ({ children, ...restProps }) => (
  //        <tr
  //          {...restProps}
  //          style={{
  //            backgroundColor: '#f0f7fd',
  //          }}
  //        >
  //          {children}
  //        </tr>
  //      ),
  //      cell: ({ children, ...restProps }) => (
  //        <td
  //          {...restProps}
  //          style={{
  //            padding: '8px',
  //                        fontSize: '15px',

  //          }}
  //        >
  //          {children}
  //        </td>
  //      ),
  //    },
  //  }
  //===============================================

   
   


        //=====================================================================================
        const [includeRate, setIncludeRate] = useState(""); 
        const[reportType,setReportType]= useState(""); 
        const[isPrintModalVisible,setIsPrintModalVisible]=useState(false);
        const[dispatchOrder ,setDispatchOrder]=useState("");
          const handlePrint = async (item) => {      
        setDispatchOrder(item);
        console.log("Dispatch Order",dispatchOrder);
          setIsPrintModalVisible(true);
        };
    
        const handleViewReport = () => {
      console.log("Viewing Report", {
        JobWork,
        reportType,
        

      });
      // Optional: Call API or navigate to report view
    };

//============================== Print Report ================================================================
  // const handleShowPdf = async () => {
  //   let isValid = true
  //   const errorObj = {}

  //   if (rackNo) {
  //     isValid = false
  //     errorObj.rackNo = 'Rack No. is required *'
  //   }

  //   setErrors(errorObj)
  //   if (!isValid) return

  //   const url = `${GetRackReleaseReportData}?rackNo=${rackNo}`

  //   try {
  //     const response = await axios.get(url, commonHeaders1)

  //     if (response.data !== null) {
  //       if (
  //         response.data === 'NOTFOUND' ||
  //         response.data === 'NODATA' ||
  //         response.status === 204
  //       ) {
  //         toast.warn('No data available!', {
  //           position: 'top-right',
  //           autoClose: 2000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //         })

  //         setLoading(false)
  //         return // Exit function early
  //       }
  
  //       let reportUrl = response.data
  //       if (reportUrl === 'NOTFOUND') {
  //         toast.warn('Report File Not Found...!!', {
  //           position: 'top-right',
  //           autoClose: 2000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //         })
  //       } else {
  //         const reportLink = BaseIPForPDF + `output/${reportUrl}`
  //         window.open(reportLink, '_blank')
  //       }
  //     }
  //   } catch (error) {
  //     setLoading(false)
  //     console.error('Error during API call:', error)
  //     toast.error('Error occurred while submitting data')
  //   }
  // }
  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
      <div
        className="row mt-3 p-3  pt-3 mb-3 rounded"
        style={{ backgroundColor: '#e0efff' }}
      >
      <div className="col-12">
  <div className="row">
    {/* JobWork No. */}
  <div className="col-12">
  <div className="row gx-2"> {/* Reduce horizontal spacing between columns */}
  
  
    
 


    <div className="col-md-4 col-lg-4 py-1">
  <label className="labels">Job Worker</label>
  <Select
    showSearch
    placeholder="Select Job Worker"
    optionFilterProp="children"
    className="w-100 compact-input"
    value={jobWorker}
    onChange={(value) => setJobWorker(value)}
    // filterOption={(input, option) =>
    //   option.children.toLowerCase().includes(input.toLowerCase())
    // }
  >
    {allWorker.map((worker) => (
      <Option key={worker.id} value={worker.id}>
        {worker.name}
      </Option>
    ))}
  </Select>
        {errors.jobWorker && <div className="errorField">{errors.jobWorker}</div>}
</div>
    {/* JobWork No. */}
  <div className="col-md-4 col-lg-4 py-1">
  <label className="labels">Select Job Work</label>
  <Select
    className="w-100 compact-input"
    value={JobWork || undefined} 
    showSearch
    placeholder="Select Job Work"
    optionFilterProp="children"
    onChange={(value) => setJobWork(value)}  
  >
    {JobWorkData.map((work) => (
      <Option key={work.jobWorkNumberId} value={work.jobWorkNumberId}>
        {`${work.jobWorkNumber} | ${work.customerName} | ${work.orderNumber}`}
        {/* {work.jobWorkNumber} */}
      </Option>
    ))}
  </Select>
  {errors.JobWork && <div className="errorField">{errors.JobWork}</div>}  
</div>

   
 {/* Table */}
  <div className="col-12 py-2"  style={{  backgroundColor: "white" }}>

    <div
                                    className="col-12 px-lg-5"
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                  >
                                    <div>
                                      <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                                      <Select
                                        defaultValue={pageSize1}
                                        onChange={handlePageSizeChange1}
                                        style={{ width: 120, textAlign: "center" }}
                                      >
                                        <Option value={10}>10</Option>
                                        <Option value={20}>20</Option>
                                        <Option value={30}>30</Option>
                                      </Select>
                                    </div>
          
                                    <div className="pt-4 pt-lg-0">
                                      <Input.Search
                                        placeholder="Search"
                                        onChange={(e) => handleSearch1(e.target.value)}
                                        style={{ width: 200, marginBottom: 16 }}
                                      />
                                    </div>
                                  </div>
          
                                  <div style={{ backgroundColor: "white" }}>
                                    {/* <Table
                                      bordered
                                      style={{ padding: "0px 20px", overflowX: "auto" }}
                            columns={columns1}
                    dataSource={filteredData1}
                                      pagination={{
                                        pageSize: pageSize1,
                                        total: totalEntries1,
                                        showTotal: (total, range) =>
                                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                        current: currentPage1,
                                        onChange: (page) => setCurrentPage1(page),
                                      }}
                                      showSorterTooltip={false}
                                      rowKey={(record) => record.orderNumberId}
                                      components={components1}
                                            size="small"
                                    /> */}
                                            <DataTable
          columns={columns1}
          data={filteredData1}
          customStyles={customStyles}
          pagination
          paginationServer
          paginationTotalRows={totalEntries1}
          paginationRowsPerPageOptions={[10, 20, 30]}
          paginationDefaultPage={currentPage1}
          onChangePage={paginationOptions.onChangePage}
          onChangeRowsPerPage={paginationOptions.onChangeRowsPerPage}
          highlightOnHover
          responsive
          striped
        />

                                  </div>

  </div>

    {/* Vehicle No. */}
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Vehicle No.</label>
      <Input
        className="w-100 compact-input"
        value={vehicleNo}
        onChange={(e) => setVehicleNo(e.target.value)}
        placeholder="Enter Vehicle No."
        maxLength={250}
      />
        {errors.vehicleNo && <div className="errorField">{errors.vehicleNo}</div>}
    </div>

    {/* Remark */}
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Remark</label>
      <Input
        className="w-100 compact-input"
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
        placeholder="Enter Remark"
        maxLength={250}
      />
        {errors.remark && <div className="errorField">{errors.remark}</div>}
    </div>

  
    {/* Buttons */}
    <div className="col-12 text-center pt-3">
      <Button
        type="submit"
        className="CancelBtn mx-1"
        onClick={handleJobWorkCancel}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        className="SubmitBtn mx-1"
        onClick={handleJobWorkSubmit}
      >
        Submit
      </Button>
    </div>
  </div>
</div>
</div>
</div>
      </div>



  <div className="row mt-3 p-3 pb-3 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
  <div className="col-12">
          <div className="row p-0 m-0">
            <div className="col-12 pb-3">
              <h5>
                <u>JOB WORK DISPATCH DETAILS</u> -{' '}
              </h5>
            
             
            </div>

          
    </div>
  </div>


  <div className="row mb-3">
    <div className="col-12 py-3 shadow border rounded" style={{ backgroundColor: 'white' }}>
      <div className="col-12 py-3 px-lg-5" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
          <Select defaultValue={pageSize} onChange={handlePageSizeChange} style={{ width: 120, textAlign: 'center' }}>
            <Option value={10}>10</Option>
            <Option value={20}>20</Option>
            <Option value={30}>30</Option>
          </Select>
        </div>
        <div className="pt-4 pt-lg-0">
          <Input.Search placeholder="Search" onChange={(e) => handleSearch(e.target.value)} style={{ width: 200, marginBottom: 16 }} />
        </div>
      </div>

      <div style={{ backgroundColor: 'white' }}>
        <Table
          bordered
          style={{ padding: '0px 20px', overflowX: 'auto' }}
          columns={columns}
          dataSource={filteredData}
          pagination={{
            pageSize: pageSize,
            total: totalEntries,
            showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
            current: currentPage,
            onChange: (page) => setCurrentPage(page),
          }}
          showSorterTooltip={false}
          rowKey={(record) => record.id}
          components={components}
        />
      </div>
    </div>

   
        <Modal
      title="Print Dispatch Report"
      open={isPrintModalVisible}
      onCancel={() => setIsPrintModalVisible(false)}
    
        onOk={handleViewReport}
          okText="View Report"
      width={500}
    >
      {/* Dispatch Information */}
      <div className="row mb-3">
        <div className="col-12  ">
          <span > Job Work Dispatch ID : <strong>{dispatchOrder.id}</strong></span>
          {/* <Input value={dispatchOrder.jobWorkNumber} readOnly className="w-100 compact-input" /> */}
        </div>
       </div>
    
      {/* Report Type Selection */}
      <div className="row mb-3">
        <div className="col-12  ">
          <label className="labels">Report Type</label>
          <Select
            className="w-100"
            value={reportType}
            onChange={(value) => setReportType(value)}
            placeholder="Select Report Type"
            showSearch
                                  optionFilterProp="children"

           
          ><Option value="1">Summary</Option>
  <Option value="2">Detailed</Option></Select>
        </div>
    
    
    
      </div>
  
    </Modal>
  </div>


</div>

   
    </div>
  )
}


export default JobWorkDispatch